<div class="container-fluid mt-3 ">
    @if (Measure) {
    <div class="row justify-content-center">
        <span class="col-12 border rounded-1 text-center" [style.background]="Measure.Color">
            <div class="fs-5 fw-bold" [style.color]="Measure.TextColor">
                {{Measure.MeasureReferenceName}}
            </div>
        </span>
    </div>

    <div class="row rounded-1 background-light mt-3 mb-3 py-3">
        <mat-form-field class="col">
            <mat-label>Code</mat-label>
            <input matInput [ngModel]="Measure.Code" placeholder="Code" readonly="">
        </mat-form-field>
    </div>

    <div class="row">
        <button class="col" color="accent" mat-raised-button (click)="openCopyPlageHoraireBox()">
            Copier une mesure
            <mat-icon class="material-symbols-outlined">
                content_copy
            </mat-icon>
        </button>
    </div>

    <div class="row mt-3">
        <span class="ms-3 display-6 fw-bold">
            Localisation
        </span>
    </div>
    <div class="row rounded-1 background-light mb-3 py-3">
        <mat-form-field class="col">
            <mat-label>Description de la localisation</mat-label>
            <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="3" cdkAutosizeMaxRows="3" [(ngModel)]="Measure.Localisation"
                      placeholder="Description de la localisation"></textarea>
        </mat-form-field>
    </div>

    <div class="row mt-3">
        <span class="ms-3 display-6 fw-bold">
            Cassette
        </span>
    </div>
    <div class="row rounded-1 background-light mb-3 py-3">
        <button class="col-auto" matPrefix mat-icon-button aria-label="barcode" (click)="openBarcodeScanning(Measure.Cassette.Id!, false)">
            <mat-icon class="material-symbols-outlined">qr_code_scanner</mat-icon>
        </button>
        <div class="col">
            <mat-form-field class="w-100">
                <mat-label>Référence Cassette</mat-label>
                <!-- (keyup)="checkBarCode($event, Measure.Cassette.Reference)" -->
                <input matInput [(ngModel)]="Measure.Cassette.Reference" placeholder="Référence Cassette" >
                @if (!checkBarCode(Measure.Cassette.Reference)) {
                    <span class="error">
                      Format non reconnu
                    </span>
                }
            </mat-form-field>
        </div>
        <div class="col">
            <mat-form-field class="w-100">
                <mat-label>Type tête prélèvement</mat-label>
                <mat-select placeholder="Type tête prélèvement" [(ngModel)]="Measure.Cassette.TypeTetePrelevement" required>
                    @for (o of TetePrelevementList; track o; let i = $index) {
                    <mat-option [value]="i + 1">
                        <span>{{o}}</span>
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-12">
            <mat-form-field class="w-100">
                <mat-label>Référence tête prélèvement</mat-label>
                <input matInput [(ngModel)]="Measure.Cassette.RefTetePrelevement" placeholder="Référence tête prélèvement">
            </mat-form-field>
        </div>
        <div class="col">
            @if (isDepose) {
            <mat-form-field class="w-100">
                <mat-label>Intégrité du filtre</mat-label>
                <mat-select placeholder="Intégrité du filtre" [(ngModel)]="Measure.Cassette.Integrite" required>
                    @for (o of IntegriteList; track o; let i = $index) {
                    <mat-option [value]="i + 1">
                        <span>{{o}}</span>
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>
            }
        </div>

        <span class="text-center">PROGRAMMATION

        </span>

        <div class="col-12">
            @for (ph of Measure.Cassette.PlageHoraireList; track ph) {
            <div class="row">
                <span class="col text-center">{{ph.Debut.toLocaleString(undefined, { day: 'numeric', month: 'numeric', hour: 'numeric', minute: 'numeric' })}}</span>
                <span class="col text-center">{{ph.Fin.toLocaleString(undefined, { day: 'numeric', month: 'numeric', hour: 'numeric', minute: 'numeric' })}}</span>
                <a class="col-auto btn-close" (click)="deletePlage(ph)"></a>
            </div>
            }
        </div>
        <div class="col-12">
            <div class="row justify-content-center m-3">
                <button class="col-11" color="primary" mat-raised-button (click)="openPlageHoraireDialog()">
                    Ajouter
                </button>
            </div>
        </div>

        <mat-form-field class="col">
            <mat-label>TOTAL (min)</mat-label>
            <input matInput [ngModel]="getTotal()" placeholder="TOTAL (min)" readonly>
        </mat-form-field>
    </div>

    <div class="row">
        <span class="ms-3 display-6 fw-bold">
            Pompe
        </span>
    </div>

    <div class="row rounded-1 background-light mb-3 py-3">
        <button class="col-auto" matPrefix mat-icon-button aria-label="barcode" (click)="openBarcodeScanning(Measure.Cassette.Id!, true)">
            <mat-icon class="material-symbols-outlined">qr_code_scanner</mat-icon>
        </button>
        <mat-form-field class="col">
            <mat-label>Référence pompe</mat-label>
            <input matInput [(ngModel)]="Measure.Cassette.Pompe.Reference" placeholder="Référence pompe">
        </mat-form-field>

        <mat-slide-toggle class="m-1" [(ngModel)]="Measure.Cassette.Pompe.ElectriciteAccessible">Electricité accessible</mat-slide-toggle>

        <div class="col-12">
            <mat-form-field class="w-100">
                <mat-label>Débit initial (L/min)</mat-label>
                <input matInput [(ngModel)]="Measure.Cassette.Pompe.DebitInitial" type="number" placeholder="Débit initial (L/min)">
            </mat-form-field>
        </div>
        <div class="col-12">
            @if (isDepose) {
            <mat-form-field class="w-100">
                <mat-label>Débit final (L/min)</mat-label>
                <input matInput [(ngModel)]="Measure.Cassette.Pompe.DebitFinal" type="number" placeholder="Débit final (L/min)">
            </mat-form-field>
            }
        </div>
        <div class="col-12">
            @if (isDepose) {
            <mat-form-field class="w-100">
                <mat-label>Ecart relatif &lt;10%</mat-label>
                <input matInput [ngModel]="computeDebitMoyInf10Percent(Measure.Cassette.Pompe)" placeholder="Ecart relatif <10%" disabled="true">
            </mat-form-field>
            }
        </div>
        <div class="col-12">
            <mat-form-field class="w-100">
                <mat-label>Compteur vol initial (L)</mat-label>
                <input matInput [(ngModel)]="Measure.Cassette.Pompe.CompteurVolInitial" type="number" placeholder="Compteur vol initial (L)">
            </mat-form-field>
        </div>

        <div class="col-12">
            @if (isDepose) {
            <mat-form-field class="w-100">
                <mat-label>Compteur vol final (L)</mat-label>
                <input matInput [(ngModel)]="Measure.Cassette.Pompe.CompteurVolFinal" type="number" placeholder="Compteur vol final (L)">
            </mat-form-field>
            }
        </div>

        <div class="col-12">
            @if (isDepose) {
            <mat-form-field class="w-100">
                <mat-label>Volume total (L)</mat-label>
                <input matInput [ngModel]="computeVolumeTotal(Measure.Cassette.Pompe)" placeholder="Volume total (L)" disabled="true">
            </mat-form-field>
            }
        </div>

        <mat-slide-toggle class="m-1" [(ngModel)]="CompteurAvecHeure">Avec heures</mat-slide-toggle>
        <div class="col-12">
            @if (!CompteurAvecHeure) {
            <mat-form-field class="w-100">
                <mat-label>Compteur horaire initial (min)</mat-label>
                <input matInput [(ngModel)]="Measure.Cassette.Pompe.CompteurHoraireInitial" type="number" placeholder="Compteur horaire initial (min)">
            </mat-form-field>
            }
        </div>
        @if (CompteurAvecHeure) {
        <div class="col-12 text-center">Compteur horaire initial</div>
        }
        @if (CompteurAvecHeure) {
        <mat-form-field class="col-6">
            <mat-label>Heures</mat-label>
            <input matInput [(ngModel)]="CompteurHoraireInitialHeures" type="number" placeholder="Heures" (keyup)="onInitialHeuresChangeEvent(Measure.Cassette.Pompe)">
        </mat-form-field>
        }
        @if (CompteurAvecHeure) {
        <mat-form-field class="col-6">
            <mat-label>Minutes</mat-label>
            <input matInput [(ngModel)]="CompteurHoraireInitialMinutes" type="number" placeholder="Minutes" (keyup)="onInitialMinutesChangeEvent(Measure.Cassette.Pompe)"
                   [formControl]="ValidMinutesForHoraireInitial">
            @if (ValidMinutesForHoraireInitial.hasError('max') || ValidMinutesForHoraireInitial.hasError('min')) {
            <mat-error>
                0 à 59
            </mat-error>
            }
        </mat-form-field>
        }
        <div class="col">
            @if (!CompteurAvecHeure && isDepose) {
            <mat-form-field class="w-100">
                <mat-label>Compteur horaire final (min)</mat-label>
                <input matInput [(ngModel)]="Measure.Cassette.Pompe.CompteurHoraireFinal" type="number" placeholder="Compteur horaire final (min)">
            </mat-form-field>
            }
        </div>
        @if (CompteurAvecHeure && isDepose) {
        <div class="col-12 text-center">Compteur horaire final</div>
        }
        @if (CompteurAvecHeure && isDepose) {
        <mat-form-field class="col-6">
            <mat-label>Heures</mat-label>
            <input matInput [(ngModel)]="CompteurHoraireFinalHeures" type="number" placeholder="Heures" (keyup)="onFinalHeuresChangeEvent(Measure.Cassette.Pompe)">
        </mat-form-field>
        }
        @if (CompteurAvecHeure && isDepose) {
        <mat-form-field class="col-6">
            <mat-label>Minutes</mat-label>
            <input matInput [(ngModel)]="CompteurHoraireFinalMinutes" type="number" placeholder="Minutes" (keyup)="onFinalMinutesChangeEvent(Measure.Cassette.Pompe)"
                   [formControl]="ValidMinutesForHoraireFinal">
            @if (ValidMinutesForHoraireFinal.hasError('max') || ValidMinutesForHoraireFinal.hasError('min')) {
            <mat-error>
                0 à 59
            </mat-error>
            }
        </mat-form-field>
        }
        <div class="col">
            @if (isDepose) {
            <mat-form-field class="w-100">
                <mat-label>Durée totale</mat-label>
                <input matInput [ngModel]="computeDureeTotal(Measure.Cassette.Pompe)" placeholder="Durée totale" disabled="true">
            </mat-form-field>
            }
        </div>

        <div class="col">
            @if (isDepose) {
            <mat-form-field class="w-100">
                <mat-label>Débit moyen (L/min)</mat-label>
                <input matInput [ngModel]="computeDebitMoy(Measure.Cassette.Pompe) | number:'1.1-1'" placeholder="Débit moyen (L/min)" disabled>
            </mat-form-field>
            }
        </div>
    </div>

    <div class="row">
        <span class="ms-3 display-6 fw-bold">
            Conditions de prélèvement
        </span>
    </div>

    <div class="row rounded-1 background-light mb-3 py-3">
        <div class="col">
            <mat-form-field class="w-100">
                <mat-label>Contexte</mat-label>
                <mat-select placeholder="Contexte" [(ngModel)]="Measure.ZoneSamplingCondition.ExpositionClimatique" (selectionChange)="ExpositionClimatiqueChange($event)" required>
                    @for (o of ExpositionClimatiqueList; track o; let i = $index) {
                    <mat-option [value]="i + 1">
                        <span>{{o}}</span>
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>

        <div class="col">
            <mat-form-field class="w-100">
                <mat-label>Vitesse vent (m/s)</mat-label>
                <input matInput [(ngModel)]="Measure.ZoneSamplingCondition.VitesseVent" type="number" placeholder="Vitesse vent (m/s)"
                       [disabled]="Measure.ZoneSamplingCondition.ExpositionClimatique === EExpostionClimatique.Interieur">
            </mat-form-field>
        </div>

        <div class="col">
            <mat-form-field class="w-100">
                <mat-label>Météo</mat-label>
                <mat-select placeholder="Météo" [(ngModel)]="Measure.ZoneSamplingCondition.Meteo" required
                            [disabled]="Measure.ZoneSamplingCondition.ExpositionClimatique === EExpostionClimatique.Interieur">
                    @for (o of MeteoList; track o; let i = $index) {
                    <mat-option [value]="i + 1">
                        <span>{{o}}</span>
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col">
            <mat-form-field class="w-100">
                <mat-label>Hygrométrie (%)</mat-label>
                <input matInput [(ngModel)]="Measure.ZoneSamplingCondition.Hygrometrie" type="text" placeholder="Hygrométrie (%)"
                       [disabled]="Measure.ZoneSamplingCondition.ExpositionClimatique === EExpostionClimatique.Interieur" numbersOnly inputmode="numeric">
            </mat-form-field>
        </div>
    </div>

    <div class="row">
        <span class="ms-3 display-6 fw-bold">
            Sécurité
        </span>
    </div>
    @if (!isDepose) {
    <div class="row rounded-1 background-light mb-3 py-3">
        <div class="col">
            <mat-form-field class="w-100">
                <mat-label>Entrée Zone</mat-label>
                <mat-select placeholder="Entrée Zone" [(ngModel)]="Measure.PoseSecurite.EntreeZone" required>
                    @for (o of EntreZoneList; track o; let i = $index) {
                    <mat-option [value]="i + 1">
                        <span>{{o}}</span>
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col">
            <mat-form-field class="w-100">
                <mat-label>EPI</mat-label>
                <mat-select placeholder="EPI" [(ngModel)]="Measure.PoseSecurite.Epi" required>
                    @for (o of EPIList; track o; let i = $index) {
                    <mat-option [value]="i + 1">
                        <span>{{o}}</span>
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
        <!-- <mat-form-field class="col">
        <input matInput [(ngModel)]="Measure.PoseSecurite.EntreeZone" placeholder="EntreeZone">
      </mat-form-field> -->
        <!-- <mat-form-field class="col">
      <input matInput [(ngModel)]="Measure.PoseSecurite.Epi" placeholder="Epi">
    </mat-form-field> -->
        <div class="col">
            <mat-form-field class="w-100">
                <mat-label>Durée d'exposition</mat-label>
                <input matInput [(ngModel)]="Measure.PoseSecurite.DureeExposition" type="number" placeholder="Durée d'exposition">
            </mat-form-field>
        </div>
    </div>
    }
    @if (isDepose) {
    <div class="row rounded-1 background-light mb-3 py-3">
        <div class="col">
            <mat-form-field class="w-100">
                <mat-label>Entrée Zone</mat-label>
                <mat-select placeholder="Entrée Zone" [(ngModel)]="Measure.DeposeSecurite.EntreeZone" required>
                    @for (o of EntreZoneList; track o; let i = $index) {
                    <mat-option [value]="i + 1">
                        <span>{{o}}</span>
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col">
            <mat-form-field class="w-100">
                <mat-label>EPI</mat-label>
                <mat-select placeholder="EPI" [(ngModel)]="Measure.DeposeSecurite.Epi" required>
                    @for (o of EPIList; track o; let i = $index) {
                    <mat-option [value]="i + 1">
                        <span>{{o}}</span>
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col">
            <mat-form-field class="w-100">
                <mat-label>Durée d'exposition</mat-label>
                <input matInput [(ngModel)]="Measure.DeposeSecurite.DureeExposition" type="number" placeholder="Durée d'exposition">
            </mat-form-field>
        </div>
    </div>
    }
    <div class="row rounded-1 background-light mb-3 py-3">
        <mat-form-field class="col">
            <mat-label>Observation</mat-label>
            <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="3" cdkAutosizeMaxRows="3" [(ngModel)]="Measure.Observation" placeholder="Observation"></textarea>
        </mat-form-field>
    </div>
    <div class="row mb-3">
        <button appPreventDoubleClick class="col" color="warn" mat-raised-button (throttledClick)="cancelMeasure()">
            Mesure non réalisée
        </button>
    </div>
    <div class="row mb-3">
        <button appPreventDoubleClick class="col" color="primary" mat-raised-button (throttledClick)="save()" [disabled]="!canSave()">
            Enregistrer
        </button>
    </div>
    }
</div>